import Breadcrumb from "../../components/Breadcrumb/Breadcrumb.js";
import PrizeBreakdownView from "../../components/Prizes/PrizeBreakdownView.js";
import TournamentSubpageHead from "../../components/SEO/TournamentSubpageHead";

import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

export default function Prizes() {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Tournaments", path: "/tournaments" },
    { label: "[Tournament Name]", path: tournamentPath(tournamentSlug) },
    { label: "Prizes" },
  ];

  return (
    <>
      <TournamentSubpageHead page="prizes" />
      <div className="flex justify-center mb-3 sm:mb-4 px-4 sm:px-0">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <PrizeBreakdownView tournamentId={tournamentId} />
    </>
  );
}
